var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealTimeDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_303",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 58,
    height: 58
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 7.25001V2.41667H36.25V7.25001H21.75ZM26.5833 33.8333H31.4167V19.3333H26.5833V33.8333ZM29 53.1667C26.0194 53.1667 23.2101 52.5927 20.5719 51.4448C17.9337 50.2969 15.6278 48.7361 13.6542 46.7625C11.6806 44.7889 10.1198 42.483 8.97188 39.8448C7.82396 37.2066 7.25 34.3972 7.25 31.4167C7.25 28.4361 7.82396 25.6267 8.97188 22.9885C10.1198 20.3504 11.6806 18.0445 13.6542 16.0708C15.6278 14.0972 17.9337 12.5365 20.5719 11.3885C23.2101 10.2406 26.0194 9.66667 29 9.66667C31.4972 9.66667 33.8938 10.0694 36.1896 10.875C38.4854 11.6806 40.6403 12.8486 42.6542 14.3792L46.0375 10.9958L49.4208 14.3792L46.0375 17.7625C47.5681 19.7764 48.7361 21.9313 49.5417 24.2271C50.3472 26.5229 50.75 28.9195 50.75 31.4167C50.75 34.3972 50.176 37.2066 49.0281 39.8448C47.8802 42.483 46.3194 44.7889 44.3458 46.7625C42.3722 48.7361 40.0663 50.2969 37.4281 51.4448C34.7899 52.5927 31.9806 53.1667 29 53.1667ZM29 48.3333C33.6722 48.3333 37.6597 46.682 40.9625 43.3792C44.2653 40.0764 45.9167 36.0889 45.9167 31.4167C45.9167 26.7444 44.2653 22.757 40.9625 19.4542C37.6597 16.1514 33.6722 14.5 29 14.5C24.3278 14.5 20.3403 16.1514 17.0375 19.4542C13.7347 22.757 12.0833 26.7444 12.0833 31.4167C12.0833 36.0889 13.7347 40.0764 17.0375 43.3792C20.3403 46.682 24.3278 48.3333 29 48.3333Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimeDefault);
export default __webpack_public_path__ + "static/media/real-time-default.abd82cb57dc81e96d9b704a55b02cca3.svg";
export { ForwardRef as ReactComponent };